export default __webpack_public_path__ + "static/media/image-keyboard.8fd1b16e.jpg";